import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ApiErrorFactory } from '../../../core/api-errors';
import { SiteService } from '../../../core/site';
import { ErrorDialog } from '../../dialog';
import { ProductAnalyticsService } from '@vendasta/product-analytics';

@Component({
  selector: 'app-primary-domain-dialog',
  templateUrl: './primary-domain.component.html',
  styleUrls: [`./primary-domain.styles.scss`],
  standalone: false,
})
export class PrimaryDomainDialogComponent {
  public siteId: string;
  public domain: string;
  public waiting = false;

  private errorDialogRef: MatDialogRef<ErrorDialog>;

  constructor(
    public dialogRef: MatDialogRef<PrimaryDomainDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private siteService: SiteService,
    public errorDialog: MatDialog,
    private apiErrorFactor: ApiErrorFactory,
    public readonly analyticsService: ProductAnalyticsService,
  ) {
    this.siteId = data.siteId;
    this.domain = data.domain;
  }

  onOKClick(): void {
    this.dialogRef.disableClose = true;
    this.waiting = true;
    this.analyticsService.trackEvent('domain:primary-domain', 'primary-domain', 'click');
    this.siteService.changePrimaryDomain(this.siteId, this.domain).subscribe(
      () => {
        this.handleSuccess();
      },
      (err) => {
        this.handleError(err);
      },
    );
  }

  onCancelClick(): void {
    this.dialogRef.close(false);
  }

  private handleSuccess(): void {
    this.waiting = false;
    this.dialogRef.close(true);
  }

  private handleError(errorResponse: HttpErrorResponse): void {
    const parsedError = this.apiErrorFactor.parseErrorResponse(errorResponse);
    this.displayErrorMessage(parsedError.getUserMessage());
    this.dialogRef.disableClose = false;
    this.waiting = false;
  }

  private displayErrorMessage(message: string): void {
    this.errorDialogRef = this.errorDialog.open(ErrorDialog, {
      data: { errMsg: message },
    });
  }
}
